import React, { useState } from "react";
import RutValidation from "./Registro";
import PersonalInfo from "./PersonalInfo";
import ContactInfo from "./ContactInfo";
import CodeVerification from "./CodeVerification";
import Success from "./Succes";
import WebProfileInfo from "./PerfilWeb";

const RegistrationFlow = () => {
  const [step, setStep] = useState(1);
  const [professionalData, setProfessionalData] = useState(null);
  const [personalInfo, setPersonalInfo] = useState(null);
  const [webProfileInfo, setWebProfileInfo] = useState(null); // New state for web profile
  const [contactInfo, setContactInfo] = useState(null);
  const [rut, setRut] = useState(null);

  const handleRutSuccess = (data) => {
    setProfessionalData(data);
    setRut(data.rut || data.datos_profesional.rut);
    setStep(2);
  };

  const handlePersonalInfoSubmit = (info) => {
    setPersonalInfo({
      ...info,
      rut: rut,
    });
    setStep(3); // Now goes to the web profile step
  };

  // New handler for web profile info
  const handleWebProfileSubmit = (info) => {
    setWebProfileInfo({
      ...info,
      rut: rut,
    });
    setStep(4); // Now goes to contact info
  };

  const handleContactInfoSubmit = async (info) => {
    setContactInfo({
      ...info,
      rut: rut,
    });
    setStep(5); // Step is now 5 for verification code
  };

  const handleCodeSuccess = () => {
    setStep(6); // Step is now 6 for success
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <RutValidation onSuccess={handleRutSuccess} />;
      case 2:
        return (
          <PersonalInfo
            data={professionalData}
            onNext={handlePersonalInfoSubmit}
            onBack={handleBack}
          />
        );
      case 3: // New web profile step
        return (
          <WebProfileInfo
            userData={{
              ...personalInfo,
              rut: rut,
            }}
            onNext={handleWebProfileSubmit}
            onBack={handleBack}
          />
        );
      case 4: // Contact info is now step 4
        return (
          <ContactInfo
            userData={{
              ...personalInfo,
              ...webProfileInfo,
              ...contactInfo, // Maintain contact info data when going back
              rut: rut,
            }}
            onNext={handleContactInfoSubmit}
            onBack={handleBack}
          />
        );
      case 5: // Code verification is now step 5
        return (
          <CodeVerification
            userData={{
              ...personalInfo,
              ...webProfileInfo,
              ...contactInfo,
              rut: rut,
            }}
            onNext={handleCodeSuccess}
            onBack={handleBack}
          />
        );
      case 6: // Success is now step 6
        return <Success />;
      default:
        return <RutValidation onSuccess={handleRutSuccess} />;
    }
  };

  return (
    <div className="min-h-screen w-full relative">
      <div className="relative">{renderStep()}</div>
    </div>
  );
};

export default RegistrationFlow;
